import React, { useState } from "react";

import Shop from "../Shops/Shop";
import Product from "./Product";
import Service from "./Service";

import styled from "styled-components";

import ProductSkeleton from "../Skeletons/ShopProductsSkeleton";
import NotFound from "../Common/NotFoundSearch";

const ShopMenuContainer = styled.div`
  width: 100%;
  height: auto;
`;
const ShopMenuMain = styled.div`
  width: 100%;
  height: 800px;
`;
const ShopMenuItems = styled.div`
  width: 25%;
  height: 100%;
  float: left;
  overflow-y: scroll;
  @media (max-width: 768px) {
    display: none;
  }
`;
const Title = styled.h2`
  float: left;
  margin: 0;
  padding: 0;
  font-weight: 500;
  width: 15%;
  @media (max-width: 768px) {
    font-size: 1.3em;
  }
`;

const ShopMenuItem = styled.p`
  background: #f5f5f5;
  margin: 0 0 10px 0;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 5px;
`;

const ShopMenuActiveItem = styled.p`
  background: #276fb7;
  margin: 0 0 10px 0;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 5px;
  color: white;
`;
const ShopProducts = styled.div`
  width: 73%;
  height: 100%;
  border: 1px solid #ccc;
  float: right;
  border-radius: 5px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;
const ShopFilters = styled.div`
  width: 95%;
  height: 50px;
  margin-left: 2.5%;
  padding: 15px 0 5px 0;
  border-bottom: 2px solid #ccc;
`;
const SearchItem = styled.div`
  float: right;
  width: 80%;
  height: 100%;
`;
const SearchBox = styled.input`
  width: 70%;
  height: 50%;
  float: right;
  padding: 6px 20px;
  border: 1px solid #eee;
  outline: none;
`;
const SelectInput = styled.select`
  width: 20%;
  padding: 10px 20px;
  border: 1px solid #eee;
`;
const SelectItem = styled.div`
  width: 100%;
  height: 50px;
  backgground: red;
`;
const ProductsAll = styled.div`
  width: 95%;
  height: 90%;
  margin: 10px 0 0 2.5%;
  overflow-y: scroll;
  padding-right: 5px;
  overflow-x: hidden;
`;
const OtherShopsConatiner = styled.div`
  width: 100%;
  height: auto;
  margin: 20px 0;
`;
const OtherShops = styled.div`
  width: 103.5%;
  display: flex;
  flex-flow: wrap;
  margin: 20px 0;
`;
const OtherShopsTitle = styled.h2`
  font-size: 1.6em;
  margin: 0;
  padding: 5px 0;
  font-weight: 500;
`;
const AllServices = styled.div`
  width: 102.8%;
  height: auto;
  display: flex;
  flex-flow: wrap;
`;
function ShopMenu(props) {
  const [searchText, setText] = useState("");
  const [activeCat, setActiveCat] = useState(null);

  const searchHandler = async (e) => {
    if (e.key === "Enter") {
      console.log("Search text", searchText);
      props.searchProducts(searchText);
    }
  };
  const filterProducts = (catId) => {
    setActiveCat(catId);
    props.filterProducts(catId);
  };
  return (
    <ShopMenuContainer>
      {localStorage.catId == "6129e467f8785a2974c9915a" ? (
        <AllServices>
          {props.loadProducts ? (
            props.products.length > 0 ? (
              props.products.map((product, id) => {
                return (
                  <Service
                    showProductHandler={props.showProductHandler}
                    key={product._id}
                    id={id}
                    product={product}
                    addToCartHandler={props.addToCartHandler}
                  />
                );
              })
            ) : (
              <div style={{ width: "100%" }}>
                <NotFound
                  title="No Service Found"
                  subTitle="We are sorry! we don't found any service realeted to your search."
                />
              </div>
            )
          ) : (
            <ProductSkeleton />
          )}
        </AllServices>
      ) : (
        <ShopMenuMain>
          <ShopMenuItems>
            {props.activeCat !== null ? (
              <ShopMenuItem onClick={props.allfilter}>All</ShopMenuItem>
            ) : (
              <ShopMenuActiveItem>All</ShopMenuActiveItem>
            )}

            {props.shop.categories.map((category) => {
              if (category.quantity > 0) {
                if (category.categoryId === props.activeCat) {
                  return (
                    <ShopMenuActiveItem
                      onClick={() => filterProducts(category.categoryId)}
                      key={category._id}
                    >
                      {category.name} ({category.quantity})
                    </ShopMenuActiveItem>
                  );
                } else {
                  return (
                    <ShopMenuItem
                      onClick={() => filterProducts(category.categoryId)}
                      key={category._id}
                    >
                      {category.name} ({category.quantity})
                    </ShopMenuItem>
                  );
                }
              } else {
                return null;
              }
            })}
          </ShopMenuItems>
          <ShopProducts>
            <ShopFilters>
              <Title>Products</Title>
              <SearchItem>
                {/* <SelectInput>
                <option>Brands</option>
                <option>Pran</option>
                <option>BD</option>
              </SelectInput> */}
                <SearchBox
                  onKeyDown={searchHandler}
                  name={searchText}
                  onChange={(e) => {
                    setText(e.target.value);
                  }}
                  placeholder="Search item"
                />
              </SearchItem>
            </ShopFilters>
            <ProductsAll>
              {props.loadProducts ? (
                props.products.length > 0 ? (
                  props.products.map((product, id) => {
                    return (
                      <Product
                        showProductHandler={props.showProductHandler}
                        key={product._id}
                        id={id}
                        product={product}
                        addToCartHandler={props.addToCartHandler}
                      />
                    );
                  })
                ) : (
                  <div style={{ width: "100%" }}>
                    <NotFound
                      title="No Products Found"
                      subTitle="We are sorry! we don't found any products realeted to your search."
                    />
                  </div>
                )
              ) : (
                <ProductSkeleton />
              )}
            </ProductsAll>
          </ShopProducts>
        </ShopMenuMain>
      )}

      <OtherShopsConatiner>
        {/* <OtherShopsTitle>Others Shop</OtherShopsTitle>
        <OtherShops>
          <Shop />
          <Shop />
          <Shop />
        </OtherShops> */}
      </OtherShopsConatiner>
    </ShopMenuContainer>
  );
}

export default ShopMenu;
